/**
 * @fileoverview The Beds tab's old addresses, sent to its new ones (D56;
 * owner, 2026-10-16: "change the url from locations to beds"). Every old link
 * keeps working: a plant card's or Seasons' bed link, a bookmark, an
 * installed icon, a link in an email or a share page.
 *
 * - /locations#location-12 (one bed, from a plant's card or Seasons) → /beds/12
 * - /locations?edit=12&more=1 (Edit bed with More about this bed open) →
 *   /beds?edit=12&more=1, which the list still reads
 * - /locations/archive → /beds/archive
 * - /locations, and anything else under it → /beds, its question kept
 *
 * Where: App, the /locations and /locations/* routes.
 * API: none. Words: none.
 *
 * @module LocationsRedirect
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** An old link's #part naming one bed: #location-12. */
const BED_HASH = /^#location-(\d+)$/;

/**
 * Where an old Beds address goes now.
 *
 * @param pathname - The old path (/locations, /locations/archive…).
 * @param search - Its question, with its "?", or ''.
 * @param hash - Its #part, or ''.
 * @returns The new address.
 */
export function bedsAddressFor(pathname: string, search: string, hash: string): string {
  const bed = BED_HASH.exec(hash)?.[1];
  if (bed) return `/beds/${bed}${search}`;
  if (/^\/locations\/archive\/?$/.test(pathname)) return `/beds/archive${search}`;
  return `/beds${search}${hash}`;
}

/**
 * Sends an old /locations address to its /beds one, in place (no extra history entry).
 */
export const LocationsRedirect: React.FC = () => {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={bedsAddressFor(pathname, search, hash)} replace />;
};
